import { domainid } from '@/utils/utils'
import axios from '../utils/aioxs'

// 获取用户列表
export function getDomainUsersApi(data) {
  return axios({
    method: 'get',
    // url: `/auth/domain/users/list`,
    url: `/users/list`,
    data,
  })
}
// 获取角色列表
export function getDomainRolesApi(data) {
  return axios({
    method: 'get',
    url: `/roles/list`,
    data,
  })
}
// 创建账户
export function postCreateAccount(data) {
  return axios({
    method: 'post',
    url: `/user`,
    data,
  })
}
// 删除指定用户
export function deleteDomainUsersApi(params) {
  return axios({
    method: 'delete',
    url: `/user/${params.id}`,
  })
}
// 修改用户
export function putUpdateAccount(data) {
  return axios({
    method: 'put',
    url: `/user`,
    data,
  })
}
// 修改用户密码
export function putUpdateAccountPassword(data) {
  return axios({
    method: 'put',
    url: `/user/${data.userid}/password`,
    data,
  })
}
// 获取单个用户
export function getSingleUserApi(params) {
  return axios({
    method: 'get',
    url: `/user/${params.userid}`,
    params,
  })
}
